'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleTooltip = require('reactackle-tooltip');

var _reactackleCore = require('reactackle-core');

var _CheckboxIconStyled = require('./styles/CheckboxIconStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  tooltipText: _propTypes2.default.string,
  theme: _propTypes2.default.object.isRequired,
  Tooltip: _propTypes2.default.func.isRequired,
  toggleTooltip: _propTypes2.default.func.isRequired,
  showTooltip: _propTypes2.default.func,
  hideTooltip: _propTypes2.default.func
};
var defaultProps = {
  checked: void 0,
  disabled: false,
  tooltipText: '',
  showTooltip: _reactackleCore.noop,
  hideTooltip: _reactackleCore.noop
};

var CheckboxIconComponent = function CheckboxIconComponent(props) {
  var Tooltip = props.Tooltip;
  var tooltip = props.tooltipText ? _react2.default.createElement(Tooltip, null, props.tooltipText) : null;
  var tooltipManagementProps = props.tooltipText ? {
    onClick: props.toggleTooltip,
    onFocus: props.showTooltip,
    onBlur: props.hideTooltip,
    onMouseEnter: props.showTooltip,
    onMouseLeave: props.hideTooltip,
    tabIndex: 1
  } : {};
  return _react2.default.createElement(_CheckboxIconStyled.CheckboxIconStyled, _extends({
    checked: props.checked,
    disabled: props.disabled
  }, tooltipManagementProps), props.theme.reactackle.components.checkbox.icon.element, tooltip);
};

CheckboxIconComponent.propTypes = propTypes;
CheckboxIconComponent.defaultProps = defaultProps;
CheckboxIconComponent.displayName = 'CheckboxIcon';
exports.default = (0, _reactackleCore.withTheme)((0, _reactackleTooltip.withTooltip)(CheckboxIconComponent, true));